import { FormationDetailProps } from "@/types/formation";

export const gestesPosturesFormation: FormationDetailProps = {
  id: "9",
  title: "Formation Gestes et Postures",
  description: "Cette formation a pour but de permettre au salarié de contribuer à sa propre sécurité et à celle des autres, par l\'application des bonnes pratiques de sécurité physique et d\'économie d\'effort.",
  duration: "7 heures (1 jour)",
  category: "Ergonomie",
  imageSrc: "/images/formations/gp.webp",
  slug: "gestes-et-postures",
  reference: "F-GP",
  price: "Sur devis – nous contacter",
  targetAudience: "Toute personne utilisant un détecteur mono gaz ou multi gaz",
  prerequisites: "Être âgé de 18 ans\nÊtre apte médical",
  objectives: [
    "Maîtriser les notions élémentaires d\'anatomie et de physiologie",
    "Observer et analyser sa situation de travail en s\'appuyant sur le fonctionnement du corps humain",
    "Identifier les différentes atteintes à la santé susceptibles d\'être encourues",
    "Capable de mettre en œuvre les principes de sécurité physique et d\'économie d\'effort",
    "Participer à la maîtrise et à la prévention du risque dans son entreprise ou son établissement"
  ],
  program: [
    {
      title: "Partie théorique 40%",
      items: [
        "Le fonctionnement du corps humain",
        "La colonne vertébrale",
        "Les ligaments, les muscles, les tendons, les nerfs",
        "Le fonctionnement de la colonne vertébrale",
        "Le fonctionnement d\'une articulation",
        "Les différentes atteintes de l\'appareil locomoteur et leurs conséquences sur la santé",
        "Les lésions traumatiques",
        "Les atteintes au niveau du dos",
        "Les TMS des membres supérieurs",
        "Les facteurs aggravants à l\'origine de l\'inflammation",
        "Les différents facteurs de risques (biomécaniques, psychosociaux, environnementaux)",
        "Les sollicitations de l\'appareil locomoteur",
        "L\'identification des situations à risques",
        "L\'analyse des déterminants",
        "Les différents éléments d\'une situation de travail",
        "Les principes de base à respecter par le déterminant de son activité physique",
        "Application des conditions de travail et principes de prévention",
        "Les principes généraux de prévention",
        "Les principes de sécurité physique et d\'économie d\'effort des postes de travail",
        "Les autorités de police techniques à la manutention",
        "Les principes de sécurité et d\'économie d\'effort",
        "Rappel de la portée et des limites des principes physiques et d\'économie d\'effort",
        "La mémorisation manuelle des charges lourdes"
      ]
    },
    {
      title: "Partie pratique 60%",
      items: [
        "Analyse des postes de travail des participants",
        "Recherche et présenter les principaux risques de son métier et leurs effets nocifs",
        "Échanges avec formateur du groupe des différents axes d\'amélioration",
        "Visite du site",
        "Observation de situation réelle de travail en s\'appuyant sur le fonctionnement du corps humain",
        "Caractérisation des risques liés à l\'activité physique et analyse des causes d\'exposition",
        "Principes de sécurité physique et d\'économie d\'effort en fonction des activités des opérateurs",
        "Application des règles de sécurité et d\'économie d\'effort face au poste de travail spécifique de chaque stagiaire",
        "Les différentes exercices pratiques mise en place seront spécifiques aux métiers exercé par les apprenants"
      ]
    }
  ],
  pedagogicalMethods: [
    "Exposés interactifs, démonstrations par le formateur, exercice sur site"
  ],
  evaluationMethods: [
    "En 1er jour de la formation : Questionnaire des besoins et positionnement de l\'apprenant",
    "Pendant la formation : Atelier pratique en situation réelle + exercices applicatifs",
    "Évaluation continue durant la formation à travers les mises en situation",
    "Fin de formation : QCM pour évaluation des acquis + évaluation de satisfaction à chaud",
    "Après la formation : Évaluation à froid pour vérifier les compétences de l\'apprenant"
  ],
  certification: "Cette action de formation sera validée par un certificat de réalisation nominative, après la réalisation du QCM final par l\'apprenant.",
  registrationProcess: [
    "Inscription par téléphone, par mail ou par le site internet",
    "Délai d\'accès selon un agenda interne de session de l\'entreprise",
    "Inscription 15 jours avant le début de la formation"
  ],
  accessibilityCriteria: "Pour toute personne en situation d\'handicap, nous sommes susceptibles d\'accueillir les personnes moins de nous contacter au préalable pour étudier toute situation.",
  formatterInfo: {
    name: "Sebastien Davrainville - SDPSI Formation",
    phone: "06.22.61.04.09",
    email: "sdpsiformation@orange.fr",
    website: "www.sdpsi-formations.fr"
  }
};
